import axios from "axios";
import secureLocalStorage from "react-secure-storage";
import { Link } from "../host/host";
const API = axios.create({ baseURL: Link });
API.interceptors.request.use((req) => {
  if (secureLocalStorage.getItem("profile")) {
    req.headers.Authorization = `Bearer ${
      JSON.parse(secureLocalStorage.getItem("profile")).token
    }`;
  }
  return req;
});

export default API;
